import * as React from "react";
import { formatDate, HH_MM } from "src/utils/dateUtils";
import { Slot } from "src/containers/event/event.types";
import { useSlotBookedOrFull } from "./useSlotBookedOrFull";

interface SlotMetaProps {
  slot: Slot;
}

export const SlotMeta: React.FC<SlotMetaProps> = ({ slot }) => {
  const { isBooked, isFull } = useSlotBookedOrFull(slot);
  const capacityClass = isBooked || isFull ? "text-secondary fs-14 fw-medium" : "text-info fs-14 fw-medium";
  return (
    <div className="d-flex justify-content-between w-100">
      <h5>
        {formatDate(slot.startDate, HH_MM)} - {formatDate(slot.endDate, HH_MM)}
      </h5>
      <span className={capacityClass}>{`${slot.bookings.length}/${slot.capacity} participants`}</span>
    </div>
  );
};
